// src/services/api.js
import axios from 'axios';
//const API_BASE_URL = 'http://localhost:8000/api/v1/sql/';


//const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://wa-04-productdatadev.azurewebsites.net/api/v1/sql/';
const API_BASE_URL = 'https://wa-05-productdatadev-budadkeqbphahyh0.northeurope-01.azurewebsites.net/api/v1/sql/';
const LANDING_API_BASE_URL = API_BASE_URL.replace('/api/v1/sql/', '/api/v1/landing/');
const ADMT_API_BASE_URL = API_BASE_URL.replace('/api/v1/sql/', '/api/v1/admt/');


// Create axios instance





const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  async (config) => {
    
    
    // Add auth token if available
    const token = localStorage.getItem('msal_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);


api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.error('Response error:', error);
    
    // Handle 401/403 Unauthorized/Forbidden errors - Auto logout
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn('Authentication failed - logging out user');
      
      // Clear stored token immediately
      localStorage.removeItem('msal_access_token');
      
      // Dispatch logout event
      window.dispatchEvent(new CustomEvent('forceLogout', {
        detail: { 
          reason: error.response?.status === 403 ? 'Access forbidden' : 'Authentication expired',
          status: error.response?.status
        }
      }));
      
      return Promise.reject(error);
    }
    
    return Promise.reject(error);
  }
);

// Create landing API instance for dashboard endpoints
const landingApi = axios.create({
  baseURL: LANDING_API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

landingApi.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('msal_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

landingApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error('Response error:', error);
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('msal_access_token');
      window.dispatchEvent(new CustomEvent('forceLogout', {
        detail: {
          reason: error.response?.status === 403 ? 'Access forbidden' : 'Authentication expired',
          status: error.response?.status
        }
      }));
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Create ADMT archive API instance (same auth/error handling, different base)
const admtApi = axios.create({
  baseURL: ADMT_API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

admtApi.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('msal_access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

admtApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    console.error('Response error:', error);
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem('msal_access_token');
      window.dispatchEvent(new CustomEvent('forceLogout', {
        detail: {
          reason: error.response?.status === 403 ? 'Access forbidden' : 'Authentication expired',
          status: error.response?.status
        }
      }));
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

// Export the configured axios instance
export { api };
// Local storage utilities
const STORAGE_KEYS = {
  CASCADED_DROPDOWNS: 'cascaded_dropdowns',
  INDEPENDENT_DROPDOWNS: 'independent_dropdowns',
  CUSTOMER_MAPPING: 'customer_mapping'
};

const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

const cacheUtils = {
  set(key, data) {
    const cacheData = {
      data,
      timestamp: Date.now()
    };
    localStorage.setItem(key, JSON.stringify(cacheData));
  },

  get(key) {
    try {
      const cached = localStorage.getItem(key);
      if (!cached) return null;
      
      const { data, timestamp } = JSON.parse(cached);
      if (Date.now() - timestamp > CACHE_DURATION) {
        localStorage.removeItem(key);
        return null;
      }
      return data;
    } catch (error) {
      console.error('Cache read error:', error);
      return null;
    }
  },

  clear(key) {
    localStorage.removeItem(key);
  }
};

// API service functions
export const apiService = {
  // Health check
  async healthCheck() {
    try {
      const response = await api.get('/health');
      return response.data;
    } catch (error) {
      throw new Error(`Health check failed: ${error.message}`);
    }
  },

  // Get cascaded dropdown values
  async getCascadedDropdowns(appliedFilters = {}) {
    try {
      // Create cache key based on filters
      const cacheKey = `${STORAGE_KEYS.CASCADED_DROPDOWNS}_${JSON.stringify(appliedFilters)}`;
      const cached = cacheUtils.get(cacheKey);
      
      if (cached) {
        
        return cached;
      }

      const params = new URLSearchParams();
      
      // Only include cascaded filter fields and date filters
      const cascadedFields = ['sales_area', 'entity', 'customer_name', 'site_name', 'date_from', 'date_to'];
      Object.entries(appliedFilters).forEach(([key, value]) => {
        if (value && cascadedFields.includes(key)) {
          params.append(key, value);
        }
      });
      
      const url = params.toString() ? `/cascaded-dropdowns?${params.toString()}` : '/cascaded-dropdowns';
      const response = await api.get(url);
      
      // Cache the result
      cacheUtils.set(cacheKey, response.data);
      
      return response.data;
    } catch (error) {
      console.error('Error fetching cascaded dropdown values:', error);
      throw new Error('Failed to fetch dropdown options');
    }
  },

  // Get independent dropdown values
  async getIndependentDropdowns() {
    try {
      const cached = cacheUtils.get(STORAGE_KEYS.INDEPENDENT_DROPDOWNS);
      
      if (cached) {
        
        return cached;
      }

      const response = await api.get('/all-independent-dropdowns');
      
      // Cache the result
      cacheUtils.set(STORAGE_KEYS.INDEPENDENT_DROPDOWNS, response.data);
      
      return response.data;
    } catch (error) {
      console.error('Error fetching independent dropdown values:', error);
      throw new Error('Failed to fetch dropdown options');
    }
  },

  // Get single independent dropdown
  async getSingleIndependentDropdown(fieldName) {
    try {
      // Try to get from cached data first
      const cachedAll = cacheUtils.get(STORAGE_KEYS.INDEPENDENT_DROPDOWNS);
      if (cachedAll && cachedAll[fieldName]) {
        return cachedAll[fieldName];
      }

      const response = await api.get(`/independent-dropdowns/${fieldName}`);
      return response.data.values;
    } catch (error) {
      console.error(`Error fetching dropdown values for ${fieldName}:`, error);
      throw new Error(`Failed to fetch ${fieldName} options: ${error.message}`);
    }
  },

  // Get customer name/number mapping
  async getCustomerMapping() {
    try {
      const cached = cacheUtils.get(STORAGE_KEYS.CUSTOMER_MAPPING);
      
      if (cached) {
        
        return cached;
      }

      // Custom query to get customer name to number mapping
      const response = await api.get('/customer-mapping');

      // Normalize shape to support multi-entity names while preserving legacy fields
      const data = response.data || {};
      const normalized = {
        nameToNumber: data.nameToNumber || {},
        nameToNumbers: data.nameToNumbers ||
          Object.entries(data.nameToNumber || {}).reduce((acc, [name, number]) => {
            acc[name] = [number];
            return acc;
          }, {}),
        numberToName: data.numberToName || {},
        total_mappings: data.total_mappings ?? 0
      };
      
      // Cache the result
      cacheUtils.set(STORAGE_KEYS.CUSTOMER_MAPPING, normalized);
      
      return normalized;
    } catch (error) {
      console.error('Error fetching customer mapping:', error);
      // Return empty mapping if endpoint doesn't exist yet
      return { nameToNumber: {}, nameToNumbers: {}, numberToName: {}, total_mappings: 0 };
    }
  },

  // Get dashboard statistics
  async getDashboardStats() {
    try {
      const response = await api.get('/dashboard-stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
      throw new Error(`Failed to fetch dashboard statistics: ${error.message}`);
    }
  },

  // Get filtered count
  async getFilteredCount(filters) {
    try {
      const response = await api.post('/count', filters);
      return response.data;
    } catch (error) {
      console.error('Error fetching count:', error);
      throw new Error('Failed to fetch count');
    }
  },

  // Search documents
  async searchDocuments(filters, page = 1, pageSize = 20) {
    try {
      const response = await api.post(`/search?page=${page}&page_size=${pageSize}`, filters);
      return {
        data: response.data.data,
        total_count: response.data.total_count,
        page: response.data.page,
        page_size: response.data.page_size,
        total_pages: Math.ceil(response.data.total_count / response.data.page_size),
        has_next: page < Math.ceil(response.data.total_count / response.data.page_size),
        has_previous: page > 1
      };
    } catch (error) {
      console.error('Error searching documents:', error);
      throw new Error(`Search failed: ${error.message}`);
    }
  },

  // NEW: General search (single search term across multiple fields)
  async generalSearch(searchTerm, page = 1, pageSize = 20) {
    try {
      const params = new URLSearchParams({
        search: searchTerm,
        page: page.toString(),
        page_size: pageSize.toString()
      });

      const response = await api.get(`/general-search?${params.toString()}`);
      return {
        data: response.data.data,
        total_count: response.data.total_count,
        page: response.data.page,
        page_size: response.data.page_size,
        total_pages: Math.ceil(response.data.total_count / response.data.page_size),
        has_next: page < Math.ceil(response.data.total_count / response.data.page_size),
        has_previous: page > 1
      };
    } catch (error) {
      console.error('Error in general search:', error);
      throw new Error(`General search failed: ${error.message}`);
    }
  },

  // NEW: Combined search (sidebar filters + general search)
  async combinedSearch(filters, generalSearch = '', page = 1, pageSize = 20) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString()
      });
      
      // Add general search if provided
      if (generalSearch && generalSearch.trim() !== '') {
        params.append('general_search', generalSearch.trim());
      }
      
      // Prepare the request body with filters
      const requestBody = {
        report_type: filters.report_type || null,
        sales_area: filters.sales_area || null,
        entity: filters.entity || null,
        customer_name: filters.customer_name || null,
        customer_entity: Array.isArray(filters.customer_entity) && filters.customer_entity.length > 0
          ? filters.customer_entity
          : (filters.customer_entity || null),
        country_name: filters.country_name || null,
        site_name: filters.site_name || null,
        date_from: filters.date_from || null,
        date_to: filters.date_to || null,
        failure_reason: filters.failure_reason || null,
        part_number: filters.part_number || null,
        description: filters.description || null,
        rig_model: filters.rig_model || null,
        rig_id: filters.rig_id || null
      };
      
      // Remove null values
      const cleanedBody = Object.entries(requestBody).reduce((acc, [key, value]) => {
        if (value !== null && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});
      

      
      const response = await api.post(`/combined-search?${params.toString()}`, cleanedBody);
      
      return {
        data: response.data.data,
        total_count: response.data.total_count,
        page: response.data.page,
        page_size: response.data.page_size,
        total_pages: Math.ceil(response.data.total_count / response.data.page_size),
        has_next: page < Math.ceil(response.data.total_count / response.data.page_size),
        has_previous: page > 1
      };
    } catch (error) {
      console.error('Combined search failed:', error);
      throw new Error(`Combined search failed: ${error.message}`);
    }
  },

  // Get document details
  async getDocumentDetails(reportId) {
    try {
      const response = await api.get(`/document/${reportId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching document ${reportId}:`, error);
      throw new Error(`Failed to fetch document details: ${error.message}`);
    }
  },

    // NEW: Get count for combined search (sidebar filters + general search)
  async getCombinedSearchCount(filters, generalSearch = '') {
    try {
      const params = new URLSearchParams();
      
      // Add general search if provided
      if (generalSearch && generalSearch.trim() !== '') {
        params.append('general_search', generalSearch.trim());
      }
      
      // Prepare the request body with filters
      const requestBody = {
        report_type: filters.report_type || null,
        sales_area: filters.sales_area || null,
        entity: filters.entity || null,
        customer_name: filters.customer_name || null,
        customer_entity: Array.isArray(filters.customer_entity) && filters.customer_entity.length > 0
          ? filters.customer_entity
          : (filters.customer_entity || null),
        country_name: filters.country_name || null,
        site_name: filters.site_name || null,
        date_from: filters.date_from || null,
        date_to: filters.date_to || null,
        failure_reason: filters.failure_reason || null,
        part_number: filters.part_number || null,
        description: filters.description || null,
        rig_model: filters.rig_model || null,
        rig_id: filters.rig_id || null
      };
      
      // Remove null values
      const cleanedBody = Object.entries(requestBody).reduce((acc, [key, value]) => {
        if (value !== null && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});
      
      const url = params.toString() ? `/combined-search-count?${params.toString()}` : '/combined-search-count';
      const response = await api.post(url, cleanedBody);
      
      return response.data;
    } catch (error) {
      console.error('Combined search count failed:', error);
      throw new Error(`Combined search count failed: ${error.message}`);
    }
  },

  // NEW: Get count for general search only
  async getGeneralSearchCount(searchTerm) {
    try {
      const params = new URLSearchParams();
      
      if (searchTerm && searchTerm.trim() !== '') {
        params.append('search', searchTerm.trim());
      }
      
      const url = params.toString() ? `/general-search-count?${params.toString()}` : '/general-search-count';
      const response = await api.get(url);
      
      return response.data;
    } catch (error) {
      console.error('General search count failed:', error);
      throw new Error(`General search count failed: ${error.message}`);
    }
  },



  // Get statistics
  async getStatistics() {
    try {
      const response = await api.get('/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching statistics:', error);
      throw new Error(`Failed to fetch statistics: ${error.message}`);
    }
  },

  // Download document
  async downloadDocument(reportId, format = 'pdf', accessToken = null) {
    try {
      // Prepare headers
      const headers = {
        'Content-Type': 'application/json',
      };

      // Add token if provided, otherwise fall back to interceptor behavior
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      const response = await api.get(`/document/${reportId}/download?format=${format}`, {
        responseType: 'blob',
        headers: headers
      });
      return response.data;
    } catch (error) {
      console.error(`Error downloading document ${reportId}:`, error);
      throw new Error(`Failed to download document: ${error.message}`);
    }
  },

  // Export search results
  async exportSearchResults(filters, format = 'csv', generalSearch = '') {
    try {
      const params = new URLSearchParams({ format });
      if (generalSearch && generalSearch.trim()) {
        params.append('general_search', generalSearch.trim());
      }

      const response = await api.post(`/export?${params.toString()}`, filters, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting search results:', error);
      throw new Error(`Failed to export results: ${error.message}`);
    }
  },

  // Clear all caches
  clearCache() {
    Object.values(STORAGE_KEYS).forEach(key => {
      cacheUtils.clear(key);
    });
  },

  async getTableConfigurations() {
    try {
      const response = await api.get('/table-configurations');
      return response.data.configurations;
    } catch (error) {
      console.error('Error fetching table configurations:', error);
      return {}; // Return empty object on error
    }
  },

  async saveTableConfiguration(configId, configuration) {
    try {
      const requestBody = {
        config_id: configId,
        name: configuration.name,
        description: configuration.description,
        columns: configuration.columns
      };

      const response = await api.post(`/table-configurations/${configId}`, requestBody);
      return response.data;
    } catch (error) {
      console.error(`Error saving table configuration ${configId}:`, error);
      throw new Error(`Failed to save table configuration: ${error.message}`);
    }
  },

  // ─── Reports Dashboard APIs ───────────────────────────────────

  // KPIs + Last Sync
  async getKpis() {
    try {
      const response = await landingApi.get('/kpis');
      return response.data;
    } catch (error) {
      console.error('Error fetching KPIs:', error);
      throw new Error(`Failed to fetch KPIs: ${error.message}`);
    }
  },

  // Favorites
  async getFavorites(page = 1, pageSize = 10) {
    try {
      const response = await landingApi.get(`/favorites?page=${page}&page_size=${pageSize}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching favorites:', error);
      throw new Error(`Failed to fetch favorites: ${error.message}`);
    }
  },

  async addFavorite(reportId) {
    try {
      const response = await landingApi.post('/favorites', { report_id: reportId });
      return response.data;
    } catch (error) {
      console.error('Error adding favorite:', error);
      throw new Error(`Failed to add favorite: ${error.message}`);
    }
  },

  async removeFavorite(reportId) {
    try {
      const response = await landingApi.delete(`/favorites/${reportId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing favorite:', error);
      throw new Error(`Failed to remove favorite: ${error.message}`);
    }
  },

  async checkFavorite(reportId) {
    try {
      const response = await landingApi.get(`/favorites/check/${reportId}`);
      return response.data;
    } catch (error) {
      console.error('Error checking favorite:', error);
      return { is_favorited: false };
    }
  },

  async bulkCheckFavorites(reportIds) {
    try {
      const response = await landingApi.post('/favorites/bulk-check', { report_ids: reportIds });
      return response.data.favorited_report_ids || [];
    } catch (error) {
      console.error('Error bulk checking favorites:', error);
      return [];
    }
  },

  // New Records
  async getNewRecords(page = 1, pageSize = 10) {
    try {
      const response = await landingApi.get(`/new-records?page=${page}&page_size=${pageSize}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching new records:', error);
      throw new Error(`Failed to fetch new records: ${error.message}`);
    }
  },

  // Notifications
  async getNotifications(unreadOnly = false) {
    try {
      const params = unreadOnly ? '?unread_only=true' : '';
      const response = await landingApi.get(`/notifications${params}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw new Error(`Failed to fetch notifications: ${error.message}`);
    }
  },

  async markNotificationsRead(notificationIds) {
    try {
      const response = await landingApi.put('/notifications/read', { notification_ids: notificationIds });
      return response.data;
    } catch (error) {
      console.error('Error marking notifications read:', error);
      throw new Error(`Failed to mark notifications read: ${error.message}`);
    }
  },

  async markAllNotificationsRead() {
    try {
      const response = await landingApi.put('/notifications/read-all');
      return response.data;
    } catch (error) {
      console.error('Error marking all notifications read:', error);
      throw new Error(`Failed to mark all notifications read: ${error.message}`);
    }
  },

  async dismissNotification(notificationId) {
    try {
      const response = await landingApi.delete(`/notifications/${notificationId}`);
      return response.data;
    } catch (error) {
      console.error('Error dismissing notification:', error);
      throw new Error(`Failed to dismiss notification: ${error.message}`);
    }
  },

  // PDF Viewer - fetches PDF bytes from proxy endpoint and returns blob URL
  async getPdfPreviewUrl(reportId) {
    try {
      const response = await landingApi.get(`/pdf-preview/${reportId}`, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error fetching PDF preview:', error);
      throw new Error(`Failed to fetch PDF preview: ${error.message}`);
    }
  },

  // Drill-down by dimension
  async getDrillDown(dimension, search = '', page = 1, pageSize = 20, sort = 'reports_desc') {
    try {
      const params = new URLSearchParams({ dimension, page, page_size: pageSize, sort });
      if (search) params.append('search', search);
      const response = await landingApi.get(`/drill-down?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching drill-down:', error);
      throw new Error(`Failed to fetch drill-down: ${error.message}`);
    }
  },

};

// ─── ADMT Archive API service ─────────────────────────────────
// Mirrors apiService's search/filter/document methods, but reads from the
// legacy ADMT_archive.admt_reportsearch_flat table via /api/v1/admt/.
export const admtApiService = {
  async getFilteredCount(filters) {
    try {
      const response = await admtApi.post('/count', filters);
      return response.data;
    } catch (error) {
      console.error('Error fetching ADMT count:', error);
      throw new Error('Failed to fetch count');
    }
  },

  async searchDocuments(filters, page = 1, pageSize = 20) {
    try {
      const response = await admtApi.post(`/search?page=${page}&page_size=${pageSize}`, filters);
      return {
        data: response.data.data,
        total_count: response.data.total_count,
        page: response.data.page,
        page_size: response.data.page_size,
        total_pages: Math.ceil(response.data.total_count / response.data.page_size),
        has_next: page < Math.ceil(response.data.total_count / response.data.page_size),
        has_previous: page > 1
      };
    } catch (error) {
      console.error('Error searching ADMT documents:', error);
      throw new Error(`Search failed: ${error.message}`);
    }
  },

  async combinedSearch(filters, generalSearch = '', page = 1, pageSize = 20) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        page_size: pageSize.toString()
      });

      if (generalSearch && generalSearch.trim() !== '') {
        params.append('general_search', generalSearch.trim());
      }

      const requestBody = {
        report_type: filters.report_type || null,
        sales_area: filters.sales_area || null,
        entity: filters.entity || null,
        customer_name: filters.customer_name || null,
        customer_entity: Array.isArray(filters.customer_entity) && filters.customer_entity.length > 0
          ? filters.customer_entity
          : (filters.customer_entity || null),
        country_name: filters.country_name || null,
        site_name: filters.site_name || null,
        date_from: filters.date_from || null,
        date_to: filters.date_to || null,
        failure_reason: filters.failure_reason || null,
        part_number: filters.part_number || null,
        description: filters.description || null,
        rig_model: filters.rig_model || null,
        rig_id: filters.rig_id || null
      };

      const cleanedBody = Object.entries(requestBody).reduce((acc, [key, value]) => {
        if (value !== null && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await admtApi.post(`/combined-search?${params.toString()}`, cleanedBody);

      return {
        data: response.data.data,
        total_count: response.data.total_count,
        page: response.data.page,
        page_size: response.data.page_size,
        total_pages: Math.ceil(response.data.total_count / response.data.page_size),
        has_next: page < Math.ceil(response.data.total_count / response.data.page_size),
        has_previous: page > 1
      };
    } catch (error) {
      console.error('ADMT combined search failed:', error);
      throw new Error(`Combined search failed: ${error.message}`);
    }
  },

  async getCombinedSearchCount(filters, generalSearch = '') {
    try {
      const params = new URLSearchParams();
      if (generalSearch && generalSearch.trim() !== '') {
        params.append('general_search', generalSearch.trim());
      }

      const requestBody = {
        report_type: filters.report_type || null,
        sales_area: filters.sales_area || null,
        entity: filters.entity || null,
        customer_name: filters.customer_name || null,
        customer_entity: Array.isArray(filters.customer_entity) && filters.customer_entity.length > 0
          ? filters.customer_entity
          : (filters.customer_entity || null),
        country_name: filters.country_name || null,
        site_name: filters.site_name || null,
        date_from: filters.date_from || null,
        date_to: filters.date_to || null,
        failure_reason: filters.failure_reason || null,
        part_number: filters.part_number || null,
        description: filters.description || null,
        rig_model: filters.rig_model || null,
        rig_id: filters.rig_id || null
      };

      const cleanedBody = Object.entries(requestBody).reduce((acc, [key, value]) => {
        if (value !== null && value !== '') {
          acc[key] = value;
        }
        return acc;
      }, {});

      const url = params.toString() ? `/combined-search-count?${params.toString()}` : '/combined-search-count';
      const response = await admtApi.post(url, cleanedBody);
      return response.data;
    } catch (error) {
      console.error('ADMT combined search count failed:', error);
      throw new Error(`Combined search count failed: ${error.message}`);
    }
  },

  async getCascadedDropdowns(appliedFilters = {}) {
    try {
      const params = new URLSearchParams();
      const cascadedFields = ['sales_area', 'entity', 'customer_name', 'site_name', 'date_from', 'date_to'];
      Object.entries(appliedFilters).forEach(([key, value]) => {
        if (value && cascadedFields.includes(key)) {
          params.append(key, value);
        }
      });
      const url = params.toString() ? `/cascaded-dropdowns?${params.toString()}` : '/cascaded-dropdowns';
      const response = await admtApi.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching ADMT cascaded dropdown values:', error);
      throw new Error('Failed to fetch dropdown options');
    }
  },

  async getIndependentDropdowns() {
    try {
      const response = await admtApi.get('/all-independent-dropdowns');
      return response.data;
    } catch (error) {
      console.error('Error fetching ADMT independent dropdown values:', error);
      throw new Error('Failed to fetch dropdown options');
    }
  },

  async getCustomerMapping() {
    try {
      const response = await admtApi.get('/customer-mapping');
      const data = response.data || {};
      return {
        nameToNumber: data.nameToNumber || {},
        nameToNumbers: data.nameToNumbers || {},
        numberToName: data.numberToName || {},
        total_mappings: data.total_mappings ?? 0
      };
    } catch (error) {
      console.error('Error fetching ADMT customer mapping:', error);
      return { nameToNumber: {}, nameToNumbers: {}, numberToName: {}, total_mappings: 0 };
    }
  },

  async getDocumentDetails(reportId) {
    try {
      const response = await admtApi.get(`/document/${reportId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching ADMT document ${reportId}:`, error);
      throw new Error(`Failed to fetch document details: ${error.message}`);
    }
  },

  async downloadDocument(reportId) {
    try {
      const response = await admtApi.get(`/document/${reportId}/download`, {
        responseType: 'blob',
      });
      return response.data;
    } catch (error) {
      console.error(`Error downloading ADMT document ${reportId}:`, error);
      throw new Error(`Failed to download document: ${error.message}`);
    }
  },

  // PDF Viewer - fetches PDF bytes and returns a blob URL for inline preview
  async getPdfPreviewUrl(reportId) {
    try {
      const response = await admtApi.get(`/document/${reportId}/download`, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      return URL.createObjectURL(blob);
    } catch (error) {
      console.error('Error fetching ADMT PDF preview:', error);
      throw new Error(`Failed to fetch PDF preview: ${error.message}`);
    }
  },

  async getStatistics() {
    try {
      const response = await admtApi.get('/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching ADMT statistics:', error);
      throw new Error(`Failed to fetch statistics: ${error.message}`);
    }
  },
};

export default apiService;